import type { UndoRedoActions } from '../../../../../modernization-common/undo-redo/types';
import type { UndoableEventPayloads } from '../events';
import { UNDOABLE_EVENTS } from '../events';
import { addAnnotationCommandFactory } from './add-annotation-command';
import { applyFrameClassificationSpanCommandFactory } from './apply-frame-classification-span-command';
import { bulkAddAnnotationsCommandFactory } from './bulk-add-annotations-command';
import { bulkUpdateAnnotationCommandFactory } from './bulk-update-annotation-command';
import { deleteAnnotationAttributeCommandFactory } from './delete-annotation-attribute-command';
import { deleteAnnotationCommandFactory } from './delete-annotation-command';
import { deleteAnnotationFrameSpanCommandFactory } from './delete-annotation-frame-span-command';
import { deleteAnnotationsCommandFactory } from './delete-annotations-command';
import { deleteRelationshipCommandFactory } from './delete-relationship-command';
import { deleteSelectedAnnotationsCommandFactory } from './delete-selected-annotations-command';
import { importAnnotationsCommandFactory } from './import-annotations-command';
import { mergePolygonsCommandFactory } from './merge-polygons-command';
import { saveRelationshipsCommandFactory } from './save-relationships-command';
import { subtractPolygonCommandFactory } from './subtract-polygon-command';
import { updateAnnotationAttributeCommandFactory } from './update-annotation-attribute-command';
import { updateAnnotationCommandFactory } from './update-annotation-command';
import { updateLabelForAnnotationCommandFactory } from './update-label-for-annotation-command';

// Command factories for undoable annotation mutations.
// Each factory implements: { execute, undo, redo? }
// Added here as each annotation mutation is migrated to atom-based undo/redo.
export const commandConfig: UndoRedoActions<void, UndoableEventPayloads> = {
  [UNDOABLE_EVENTS.SAVE_RELATIONSHIPS]: saveRelationshipsCommandFactory,
  [UNDOABLE_EVENTS.DELETE_RELATIONSHIP]: deleteRelationshipCommandFactory,
  [UNDOABLE_EVENTS.ADD_ANNOTATION]: addAnnotationCommandFactory,
  [UNDOABLE_EVENTS.UPDATE_ANNOTATION]: updateAnnotationCommandFactory,
  [UNDOABLE_EVENTS.DELETE_ANNOTATION]: deleteAnnotationCommandFactory,
  [UNDOABLE_EVENTS.DELETE_ANNOTATIONS]: deleteAnnotationsCommandFactory,
  [UNDOABLE_EVENTS.IMPORT_ANNOTATIONS]: importAnnotationsCommandFactory,
  [UNDOABLE_EVENTS.BULK_ADD_ANNOTATIONS]: bulkAddAnnotationsCommandFactory,
  [UNDOABLE_EVENTS.MERGE_POLYGON]: mergePolygonsCommandFactory,
  [UNDOABLE_EVENTS.SUBTRACT_POLYGON]: subtractPolygonCommandFactory,
  [UNDOABLE_EVENTS.DELETE_SELECTED_ANNOTATIONS]: deleteSelectedAnnotationsCommandFactory,
  [UNDOABLE_EVENTS.DELETE_ANNOTATION_FRAME_SPAN]: deleteAnnotationFrameSpanCommandFactory,
  [UNDOABLE_EVENTS.UPDATE_ALL_ANNOTATION_FRAME_SPAN]: bulkUpdateAnnotationCommandFactory,
  [UNDOABLE_EVENTS.UPDATE_LABEL_FOR_ANNOTATION]: updateLabelForAnnotationCommandFactory,
  [UNDOABLE_EVENTS.APPLY_FRAME_CLASSIFICATION_SPAN]: applyFrameClassificationSpanCommandFactory,
  [UNDOABLE_EVENTS.UPDATE_ANNOTATION_ATTRIBUTE]: updateAnnotationAttributeCommandFactory,
  [UNDOABLE_EVENTS.DELETE_ANNOTATION_ATTRIBUTE]: deleteAnnotationAttributeCommandFactory
};